import { Point2D } from '@shared/models/geometry.model';
import { segmentsIntersect } from './geometry.helpers';

/**
 * Check if a polygon has self-intersecting edges
 * @param points Array of polygon points
 * @returns True if the polygon has self-intersecting edges, false otherwise
 */
export const isPolygonSelfIntersecting = (
  points: ReadonlyArray<Point2D>,
): boolean => {
  // Check for self-intersecting edges
  for (let i = 0; i < points.length; i++) {
    const p1 = points[i];
    const p2 = points[(i + 1) % points.length];
    if (!p1 || !p2) continue;

    // Check against all other edges, skipping adjacent ones
    for (let j = i + 2; j < points.length; j++) {
      // Skip the last edge if it's adjacent to the first edge
      if (i === 0 && j === points.length - 1) continue;

      const q1 = points[j];
      const q2 = points[(j + 1) % points.length];
      if (!q1 || !q2) continue;

      if (segmentsIntersect(p1, p2, q1, q2)) {
        return true;
      }
    }
  }

  return false;
};
